<template>
  <div>
    <div v-if="!category" style="position: relative; padding: 150px 0">
      <LoadingBox />
    </div>

    <div v-else>
      <CategoryHeadline :category="category" />

      <div class="container pt-4 pb-4" style="position: relative">
        <LoadingBox
          size="sm"
          v-if="isLoading"
        />

        <div v-else>
          <CoursesCategoryList
            v-if="courses.length"
            :courses="courses"
          />

          <div v-else class="row mt-4 mb-4">
            <div class="col-md-8">
              <PrimaryTitle class="font-weight-bold mb-3">Opa {{ user.firstname }}, coisa boa vem chegando aí, pode confiar!</PrimaryTitle>

              <p class="mb-3">O CyberClass está em <b>constante evolução</b>, a gente aqui não deixa você com conteúdo defasado! Estamos sempre atualizando nosse conteúdo e, é claro, criando muito mais conteúdo exclusivo.</p>

              <p class="mb-3">Já estamos trazendo conteúdo sobre <b>{{ category.name }}</b>, por isso fique ligado que em breve tudo estará disponível aqui.</p>
              
              <p class="mb-3">Não se esqueça {{ user.firstname }}, estamos juntos nessa!</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import LoadingBox from '@/components/layout/LoadingBox'
  import CategoryHeadline from '@/components/category/CategoryHeadline'
  import CoursesCategoryList from '@/components/course/CoursesCategoryList'
  import PrimaryTitle from '@/components/text/titles/PrimaryTitle'

  export default {
    components: {
      CategoryHeadline,
      CoursesCategoryList,
      LoadingBox,
      PrimaryTitle,
    },

    data: () => ({
      isLoading: false,
      category: null
    }),

    mounted () {
      this.defineCategory()

      if (!this.courses.length) { // This avoid loading the resources once again
        this.fetchCourses()
      }
    },

    computed: {
      ...mapGetters('courseCategory', ['courseCategories']),

      ...mapGetters('course', ['coursesByCategory']),

      ...mapGetters('user', ['user']),

      slug () {
        return this.$route.params.slug
      },

      courses () {
        if (!this.category) {
          return []
        }

        const coursesMeta = this.coursesByCategory(this.category.id)

        if (!coursesMeta) {
          return []
        }

        return coursesMeta.courses
      },
    },

    watch: {
      courseCategories (newValue) {
        if (newValue) {
          this.defineCategory()
          this.fetchCourses()
        }
      },
    },

    methods: {
      ...mapActions('course', ['fetchCoursesByCategory']),

      defineCategory () {
        const all = this.courseCategories.reduce((acc, c) => {
          acc.push(c)
          !c.categories.length || c.categories.map(d => acc.push(d))
          return acc
        }, [])

        return this.category = all
          .find(category => category.slug == this.slug)
      },

      async fetchCourses () {
        if (!this.category) {
          this.$router.replace({ name: 'home' })
        }

        this.isLoading = true

        await this.fetchCoursesByCategory(this.category.id)

        this.isLoading = false
      }
    }
  }
</script>
